import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import ButtonLink from 'components/ButtonLink'
import ROUTES from 'config/routes.json'
import content from 'prismic-translates/page-my-games.json'
import { INTERNAL_GAME_NAVIGATION, setDataToSessionStorage } from 'utils/sessionStorage'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  gameTypeName: 'lotto' | 'slot' | 'all' | 'table' | 'new' | 'bingo'
}
const messageRecords: {
  [key: string]: {
    title: string
    caption: string
    button: string
    link: string
  }
} = {
  bingo: {
    title: 'Bingo',
    caption: 'bingo',
    button: 'bingo',
    link: `${ROUTES.BINGO_GAME_PLAY}?refererPath=emptyPreviouslyPlayed`,
  },
  slot: {
    title: 'Slots',
    caption: 'slots',
    button: 'slots',
    link: ROUTES.GAMES_SLOTS,
  },
  table: {
    title: 'Table Games',
    caption: 'table games',
    button: 'table games',
    link: ROUTES.GAMES_TABLE,
  },
  lotto: {
    title: 'Lotteries',
    caption: 'lotteries',
    button: 'lotteries',
    link: ROUTES.GAMES_LOTTOS,
  },
  new: {
    title: 'New Games',
    caption: 'new games',
    button: 'new games',
    link: ROUTES.GAMES_NEW,
  },
  all: {
    title: 'Games',
    caption: 'games',
    button: 'games',
    link: ROUTES.HOME,
  },
}

export default function NoPlayedGames(props: Props) {
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <h6 className={classes.title} data-test={`${props.gameTypeName}-no-played-header`}>
          {t('no_one')} {messageRecords[props.gameTypeName].title} {t('have_been_played')}
        </h6>

        <p className={classes.text} data-test={`${props.gameTypeName}-no-played-text`}>
          {messageRecords[props.gameTypeName].title} {t('play_to_get_started')}{' '}
          {messageRecords[props.gameTypeName].caption} {t('now')}
        </p>

        <ButtonLink
          variant='contained'
          className={classes.btnLink}
          href={messageRecords[props.gameTypeName].link}
          data-test={`${props.gameTypeName}-no-played-button`}
          onClick={() => {
            if (props.gameTypeName === 'bingo') {
              setDataToSessionStorage(INTERNAL_GAME_NAVIGATION, 'true')
            }
          }}
        >
          {t('play')} {messageRecords[props.gameTypeName].button}
        </ButtonLink>
      </div>
    </div>
  )
}
